import React from 'react';
import { useTranslation } from 'react-i18next';
import NavbarSimple from '../components/layout/NavbarSimple';
import FooterEnhanced from '../components/layout/FooterEnhanced';
import CTAButton from '../components/CTAButton';

const TermsConditionsPage = () => {
  const { i18n } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50">
      <NavbarSimple />
      <CTAButton />
      
      {/* Hero */}
      <div className="bg-gradient-to-r from-wazin-navy to-wazin-navy-700 text-white py-20 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {i18n.language === 'ar' ? 'الشروط والأحكام' : 'Terms & Conditions'}
          </h1>
          <p className="text-xl text-wazin-gold-100">
            {i18n.language === 'ar' 
              ? 'شروط استخدام خدماتنا القانونية'
              : 'Terms of using our legal services'
            }
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <p className="text-gray-600 text-lg leading-relaxed mb-8">
            {i18n.language === 'ar'
              ? 'هذه الصفحة قيد الإعداد. سيتم تحديثها قريباً بالشروط والأحكام الكاملة لشركة وازن للمحاماة.'
              : 'This page is under preparation. It will be updated soon with the complete terms and conditions of Wazin Law Firm.'
            }
          </p>
          
          <div className="border-t border-gray-200 pt-8">
            <h3 className="text-2xl font-bold text-wazin-navy mb-4">
              {i18n.language === 'ar' ? 'للاستفسارات' : 'For Inquiries'}
            </h3>
            <p className="text-gray-700">
              {i18n.language === 'ar' ? 'البريد الإلكتروني: ' : 'Email: '}
              <a href="mailto:info@wazin.law" className="text-wazin-gold hover:underline">
                info@wazin.law
              </a>
            </p>
            <p className="text-gray-700 mt-2" dir="ltr">
              {i18n.language === 'ar' ? 'الهاتف: ' : 'Phone: '}
              <a href="tel:+966122226665" className="text-wazin-gold hover:underline">
                +966 12 222 6665
              </a>
            </p>
          </div>
        </div>
      </div>

      <FooterEnhanced />
    </div>
  );
};

export default TermsConditionsPage;